import Branch from "branch-sdk";
import { default as default2 } from "branch-sdk";
const ua = `${window.navigator.userAgent || navigator.vendor || window.opera || ""}`.toLowerCase();
const branchSessionDataKey = `branch_data-${Date.now()}`;
const BranchSessionData = (branchIOConfig) => new Promise((resolve, reject) => {
  if (window[branchSessionDataKey]) {
    resolve(window[branchSessionDataKey]);
    return;
  }
  const branchKey = branchIOConfig.branchKey;
  if (!branchKey || branchKey === "") {
    console.warn(`Couldn't determine branchIO api key. Not initializing branch.io`);
    return;
  }
  Branch.init(branchKey, { retries: 3, retry_delay: 20 }, (err, data) => {
    if (err) {
      reject(err);
    } else {
      window[branchSessionDataKey] = data;
      resolve(data);
    }
  });
});
const isInstagramBrowser = () => {
  return ua.indexOf("instagram") >= 0;
};
const isFaceBookBrowser = () => {
  return ua.indexOf("fban") >= 0 || ua.indexOf("fbav") >= 0;
};
const isInstagramOrFBBrowser = () => {
  return isInstagramBrowser() || isFaceBookBrowser() ? true : false;
};
const setupDeepView = (trackingData) => {
  return new Promise(
    (resolve, reject) => Branch.deepview(
      {
        data: trackingData
      },
      {},
      (e) => {
        if (e) {
          reject(e);
        } else {
          resolve();
        }
      }
    )
  );
};
const runDeepViewCTA = () => {
  Branch.deepviewCta();
};
export {
  BranchSessionData,
  default2 as default,
  isFaceBookBrowser,
  isInstagramBrowser,
  isInstagramOrFBBrowser,
  runDeepViewCTA,
  setupDeepView,
  ua
};
//# sourceMappingURL=Branch.js.map
